import { Component, OnInit, ViewChild, EventEmitter, ElementRef } from '@angular/core';
import { AzureFunctionsService, Status, Subscription, OnboardingProcessModel, IProcess, IProcessStep } from 'src/app/azurefunctions/azure-functions.service';
import { BaseAutorizeComponent } from '../shared/base-authorize.component';
import { BroadcastService, MsalService } from '@azure/msal-angular';


@Component({
  selector: 'app-offboarding',
  templateUrl: './offboarding.component.html',
  styleUrls: ['./offboarding.component.css']
})
export class OffBoardingComponent extends BaseAutorizeComponent {

  errorMessage: string;
  submitted: boolean = false;
  working: boolean;
  loading: boolean = true;
  confirmed: boolean = false;
  subcription: Subscription;
  process: IProcess;
  allEditions: boolean;
  hasError: boolean;

  constructor(broadcastService: BroadcastService, authService: MsalService, private functionsService: AzureFunctionsService) { 
    super(broadcastService, authService)
  }

  onInitChild() {
    this.functionsService.getOffboardingProcess().then((model) => {
      this.subcription = model.subscription;
      this.initSteps(model);
      this.loading = false;
    },
    (e) => {
      this.hasError = true;
      this.errorMessage = "Unable to load application steps"; 
      this.loading = false;
    });
  }

  initSteps(model: OnboardingProcessModel){
    this.process = model.process;
  }

  onConfirmChanged = (value) => {
      this.confirmed = value;
  }

  // onAllEditionChanged = (value) => {
  //   this.allEditions = value;
  // }

  onEditionChooseChanged(step) {
    return (value) => {
      if(step.uiFunctionName == "*")
        this.allEditions = value;
      else
        step.selected = value;
      
    }
  }

  submitRequest(){
    this.errorMessage = null;
    this.working = true;

    let editions:string[] = [];
    if(this.allEditions){
      editions.push("*");
    }
    else{
      for (let i = 0; i < this.process.steps.length; i++) {
        const step = this.process.steps[i];
        if(step.selected){
          editions.push(step.uiFunctionName);
        }
      }
    }

    if(editions.length == 0){
      this.hasError = true;
      this.errorMessage = "Please select at least one edition to offboard";
      return;
    }
    
    this.functionsService.startOffboardProcess(editions).then(
      () => {
        this.submitted = true;
        this.working = false;
      },
      (e) => {
        this.errorMessage = e.error || e.message;
        this.hasError = true;
        this.working = false;
        this.confirmed = false;
      });
  }
}
